<template>
  <div class="main">
    <div class="top-item-container">
      <HomeTopItem
        :label="$t('Home.accessDomain')"
        :itemCount="String(homeStatData.hosts || 0)"
        :imgPath="require('@/assets/images/home/lj_domain.png')"
      />

      <HomeTopItem
        :label="$t('Home.attackedDomain')"
        :itemCount="String(attacksCount)"
        :imgPath="require('@/assets/images/home/hited_domain.png')"
      />

      <HomeTopItem
        :label="$t('Home.ProductQuantity')"
        :itemCount="String(homeStatData.products || 0)"
        :imgPath="require('@/assets/images/home/product_count.png')"
      />

      <HomeTopItem
        :label="$t('Home.MaximumTrafficDomain')"
        itemCount="0"
        :imgPath="require('@/assets/images/home/most_ll_domain.png')"
      />
    </div>
    <!--  -->
    <div class="bottom-bar">
      <div class="bottom-left">
        <div class="left-container">
          <div class="left-selected">
            <!-- <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in userSelectsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select> -->
          </div>
          <v-chart class="left-chart" :options="options" autoresize theme="light" />
        </div>
        <!-- <div class="left-towchart">
          <HomeBarEchart />
        </div> -->
        <div class="chart-tap"></div>
        <div style="margin-top: 10px;">
          <v-chart class="left-chart" :options="options2" autoresize theme="light" />
        </div>
      </div>
      <div class="bottom-right">
        <!-- <HomeRightNotif /> -->

        <div>
          <!--  -->
        
       <el-table
       :data="tableData"
       style="width: 100%"
    >
    
        <el-table-column
          align="center"
          prop="fromHost"
          :label="$t('Home.Domain')"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="counts"
          :label="$t('Home.Attacks')"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="connection"
          :label="$t('Home.Connections')"
        >
        </el-table-column>

       </el-table>
          <!--  -->
        </div>
      </div>
    </div>

    <!--  -->

    <div class="bottom-view">

    </div>
  </div>
</template>

<script>
import HomeTopItem from "@/components/HomeTopItem.vue";
import HomeBarEchart from "@/components/homeBarEchart.vue";
import HomeRightNotif from "@/components/HomeRightNotif.vue";
import unOther from "@/views/dev/unOther.vue";
import echarts from "echarts";
import {
  TopTenLLChart,
  hostConnection,
  homeStatic,
  productList,
  TopOtherTJ
} from "@/service/requestRes";
export default {
  components: {
    HomeTopItem,
    HomeBarEchart,
    HomeRightNotif,
    unOther
  },
  data() {
    return {
      chartData1: [],
      homeStatData: {},
      attacksCount: 0,
      dataAxis: [],
      ydata: {},
      hostDict: {},
      tableData: [],
      // headerLables: [
      //   { label: "域名", value: "fromHost" },
      //   { label: "攻击次数", value: "counts" },
      //   { label: "链接数", value: "connection" }
      // ],
      options: {},
      options2: {},
      firstOptions1: "",
      firstOptions2: "",
      userSelectsOptions: [],
      value: ""
    };
  },
  computed: {
    headerLables() {
      return [
        { label: this.$t("Home.Domain"), value: "fromHost" },
        { label: this.$t("Home.Attacks"), value: "counts" },
        { label: this.$t("Home.Connections"), value: "connection" }
      ]
    }
  },
  mounted() {
    // this.getFirstChart();

    this.loadChartData(
      '{"host":["test.bai-du.com"],"data":[{"time":"2021-01-21T14:00:00+08:00","test.bai-du.com":0,"test.vue.com":0}]}'
    );
    this.getHomeStatic();
    this.getAllProductList({ page: 1 });
    this.otherTJ("hits");
    this.otherTJ("flows");
  },

  watch: {
    "$i18n.locale"(newValue) {
      this.otherTJ("hits");
      this.otherTJ("flows");
    }
  },
  methods: {
    otherTJ(func) {
      TopOtherTJ({
        func,
        interval_day: "60m",
        interval_time: "5m"
      }).then(res => {
        const { data, code, msg } = res || {};
        if (code == 1) {
          this.loadChartData2(data, func);
        }
      });
    },

    loadChartData2(data1, func) {
      try {
        var data = JSON.parse(data1) || {};
        let series = [];

        if (func == "flows") {
          series.push({
            name: this.$t("Home.outnetl"),
            barWidth: "28px",
            type: "bar",
            itemStyle: {
              normal: {
                // 柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 4, 4],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#87B7FF" }, // 柱图渐变色
                  { offset: 1, color: "#4F81FF" } // 柱图渐变色
                ])
              }
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#87B7FF" }, // 柱图高亮渐变色
                { offset: 1, color: "#4F81FF" } // 柱图高亮渐变色
              ])
            },
            data: data.map(v => {
              return Number(v["sendflow"].toFixed(2));
            })
          });

          this.options = {
            title: {
              text: this.$t("Home.outnetll")
            },
            tooltip: {
              formatter: function(params, ticket, callback) {
                var showContent = params.seriesName + "：" + params.value + "M";
                return showContent;
              }
            },
            legend: {
              data: [this.$t("Home.outnetll")]
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: {
              type: "category",
              // boundaryGap: false,
              data: data.map(item => {
                return this.$moment(item.time).format("MM-DD HH:mm");
              }),
              axisLabel: {
                textStyle: {
                  color: "#A1A7C4",
                  "font-family": "Helvetica-Bold",
                  "font-size": "12px"
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              z: 10
            },
            yAxis: {
              type: "value",
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                textStyle: {
                  "font-family": "Helvetica-Bold",
                  "font-size": "12px",
                  color: "#A1A7C4"
                }
              }
            },
            series: series
          };
        } else {
          series.push({
            name: this.$t("Home.Requesthitrate"),
            barWidth: "14px",
            type: "bar",
            itemStyle: {
              normal: {
                // 柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 4, 4],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: "#4F81FF" }, // 柱图渐变色
                  { offset: 0, color: "#87B7FF" } // 柱图渐变色
                ])
              }
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: "#87B7FF" }, // 柱图高亮渐变色
                { offset: 0, color: "#4F81FF" } // 柱图高亮渐变色
              ])
            },
            data: data.map(v => {
              return Number(v["hits"].toFixed(2));
            })
          });

          series.push({
            name: this.$t("Home.Traffichitrate"),
            barWidth: "14px",
            type: "bar",
            itemStyle: {
              normal: {
                // 柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 4, 4],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#87B75B" }, // 柱图渐变色
                  { offset: 1, color: "#FFFACD" } // 柱图渐变色
                ])
              }
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#87B7FF" }, // 柱图高亮渐变色
                { offset: 1, color: "#4F81FF" } // 柱图高亮渐变色
              ])
            },
            data: data.map(v => {
              return Number(v["flows"].toFixed(2));
            })
          });

          this.options2 = {
            title: {
              text: this.$t("Home.Cachehitrate")
            },
            tooltip: {
              formatter: function(params, ticket, callback) {
                var showContent = params.seriesName + "：" + params.value + "%";
                return showContent;
              }
            },
            legend: {
              data: [this.$t("Home.Requesthitrate"), this.$t("Home.Traffichitrate")]
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: {
              type: "category",
              // boundaryGap: false,
              data: data.map(item => {
                return this.$moment(item.time).format("MM-DD HH:mm");
              }),
              axisLabel: {
                textStyle: {
                  color: "#A1A7C4",
                  "font-family": "Helvetica-Bold",
                  "font-size": "12px"
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              z: 10
            },
            yAxis: {
              type: "value",
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                textStyle: {
                  "font-family": "Helvetica-Bold",
                  "font-size": "12px",
                  color: "#A1A7C4"
                }
              }
            },
            series: series
          };
        }
      } catch (error) {}
    },

    getAllProductList({ page }) {
      productList({
        page,
        limit: 100
      }).then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
          this.userSelectsOptions =
            list.data &&
            list.data.map(item => {
              return {
                label: item.name,
                value: item.id
              };
            });

          const first = this.userSelectsOptions[0];
          this.value = first.value;
        }
      });
    },
    getAttackH(host) {
      hostConnection(host).then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const ParseData = JSON.parse(data) || [];
          this.hostDict[host] = data;
          const keys = Object.keys(this.hostDict) || [];
          const tableD = [];
          keys &&
            keys.forEach(key => {
              const value = this.hostDict[key];
              const abc = JSON.parse(value)[0] || {};
              console.log("&&&");
              const a = { domain: key, ...abc };
              tableD.push(a);
            });
          this.tableData = tableD;
          console.debug(tableD);
        } else {
          msg && this.$message({
            message: msg,
            type: "error"
          });
        }
      });
    },
    // 跳转到子域名
    tochildDomain(item) {
      debugger;
      this.$router.push({ name: "subdomains", params: { id: item.id } });
    },
    getAttackHostConnection(host) {
      let ret_conn = 0;
      hostConnection(host).then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const ParseData = JSON.parse(data) || [];
          console.debug(ParseData);
          if (ParseData.length > 0) {
            const { connection } = ParseData[0] || {};
            ret_conn = connection;
          } else {
            ret_conn = 0;
          }
          this.tableData.forEach(item => {
            if (item["fromHost"] == host) {
              item["connection"] = ret_conn;
            }
          });
          console.debug(this.tableData);
        } else {
          msg && this.$message({
            message: msg,
            type: "error"
          });
        }
      });
      return ret_conn;
    },
    getHomeStatic() {
      homeStatic().then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.homeStatData = data;
          this.attacksCount = data.attacks.length;
          var attacksData = [];
          this.tableData = data.attacks.map(x => {
            return {
              connection: null,
              ...x
            };
          });
          data.attacks.forEach(attackItem => {
            this.getAttackHostConnection(attackItem.fromHost);
          });
        } else {
          msg && this.$message({
            message: msg,
            type: "error"
          });
        }
      });
    },
    getFirstChart() {
      TopTenLLChart().then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          try {
            // const test = "{\"host\":[\"test.bai-du.com\",\"test.vue.com\"],\"data\":[{\"time\":\"2021-01-21T14:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-21T15:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-21T16:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-21T17:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-21T18:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-21T19:00:00+08:00\",\"test.bai-du.com\":0.0038814544677734375,\"test.vue.com\":0},{\"time\":\"2021-01-21T20:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-21T21:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-21T22:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0.044750213623046875},{\"time\":\"2021-01-21T23:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T00:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T01:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T02:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T03:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T04:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T05:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T06:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T07:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T08:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T09:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T10:00:00+08:00\",\"test.bai-du.com\":1.0916595458984375,\"test.vue.com\":19.338651657104492},{\"time\":\"2021-01-22T11:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T12:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0},{\"time\":\"2021-01-22T13:00:00+08:00\",\"test.bai-du.com\":0.0024213790893554688,\"test.vue.com\":0.15796756744384766},{\"time\":\"2021-01-22T14:00:00+08:00\",\"test.bai-du.com\":0,\"test.vue.com\":0.006766319274902344}]}";
            this.loadChartData(data);
          } catch (e) {
            console.error(e);
          }
          this.chartData1 = data;
        } else {
         msg &&  this.$message({
            message: msg,
            type: "error"
          });
        }
      });
    },
    loadChartData(mydata) {
      var { host, data } = JSON.parse(mydata) || {};
      data = (data.length && data) || [{ time: new Date() }];
      let series = [];
      host.forEach(item => {
        series.push({
          // name: '流量排行Top10',
          barWidth: "28px",
          type: "bar",
          itemStyle: {
            normal: {
              // 柱形图圆角，初始化效果
              barBorderRadius: [4, 4, 4, 4],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#87B7FF" }, // 柱图渐变色
                { offset: 1, color: "#4F81FF" } // 柱图渐变色
              ])
            }
          },
          emphasis: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#87B7FF" }, // 柱图高亮渐变色
              { offset: 1, color: "#4F81FF" } // 柱图高亮渐变色
            ])
          },
          data: data.map(v => {
            return Number(v[item].toFixed(2));
          })
        });
      });
      this.options = {
        title: {
          text: ""
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: host
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        // toolbox: {
        //     feature: {
        //         saveAsImage: {}
        //     }
        // },
        xAxis: {
          type: "category",
          // boundaryGap: false,
          data: data.map(item => {
            return this.$moment(item.time).format("MM-DD HH:mm");
          }),
          axisLabel: {
            textStyle: {
              color: "#A1A7C4",
              "font-family": "Helvetica-Bold",
              "font-size": "12px"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              "font-family": "Helvetica-Bold",
              "font-size": "12px",
              color: "#A1A7C4"
            }
          }
        },
        series: series
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 1320px;
  margin: 28px auto;
  .top-item-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .bottom-bar {
    display: flex;
    justify-content: space-between;
    width: 1320px;
    margin-top: 24px;
    position: relative;
    background-color: white;
    padding: 0, 12px 12px 12px;
    .bottom-left {
      width: 980px;
      padding: 12px;
      background-color: white;
      border-right: 20px solid #f5f6fa;
      .left-chart {
        width: 100%;
        min-height: 396px;
        padding: 2px;
        background-color: white;
      }
      // :nth-child(1) {
      //   width: 100%;
      //   min-height: 396px;
      //   padding: 2px;
      //   background-color: white;
      // }
      .left-towchart {
        margin-top: 24px;
        padding: 2px;
        background-color: white;
      }
      // :nth-last-child(1) {
      //   margin-top: 24px;
      //   padding: 2px;
      //   background-color: white;
      // }
    }
    .bottom-right {
      width: 346px;
      height: 940px;
      background-color: white;
      border-radius: 4px;
      box-shadow: 0 1px 4px 0 rgba(21, 34, 50, 0.08);
    }
  }
}
.bottom-add {
  position: absolute;
  top: 420px;
  background-color: white;
  padding: 24px;
  width: 1225px;
}
.other-height {
  width: 100px;
  height: 1100px;
}
.left-container {
  position: relative;
  .left-selected {
    position: absolute;
    top: 0px;
    z-index: 9;
    ::v-deep .el-input__inner {
      height: 28px;
      line-height: 28px;
      font-size: 12px;
    }
    ::v-deep .el-input__icon {
      line-height: 0;
    }
  }
}

.chart-tap {
  background-color: #f5f6fa;
  height: 20px;
  width: 980px;
  margin-left: -30px;
}
.bottom-view {
  width: 100%;
  // height: 350px;
  height: 80px;
  background-color: #f5f6fa;
  position: absolute;
  bottom: 0px;
}
</style>
